<template>
  <v-btn icon small text @click="contatos" title="Lista de contatos">
    <v-icon small>mdi-contacts</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: ["params"],
  methods: {
    contatos() {
      this.$store.commit("contato/setParamsLista", this.params);
    },
  },
};
</script>
